import { FeatureFlag } from '../FeatureFlag';

export const enableEnhancedTableProgress = new FeatureFlag({
    key: 'enable-enhanced-table-progress',
    createdOn: '2026-08-06',
    defaultValue: false,
});
